import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "permissionAbilitiesLabel",
    "currentPermissions"
  ]

  connect() {
    this.toggleAbilitiesLabel(this.currentPermissionsTarget.value)
  }

  updateAbilitiesLabel(e) {
    this.toggleAbilitiesLabel(e.target.value)
  }

  toggleAbilitiesLabel(ability) {
    this.permissionAbilitiesLabelTargets.forEach((labelTarget) => {
      if (labelTarget.dataset.permissionId == ability) {
        labelTarget.classList.remove("hidden")
      } else {
        labelTarget.classList.add("hidden")
      }
    })
  }
}
